import {
	SET_PROGRAMMES,
	SET_PROGRAMME,
	CLEAR_PROGRAMMES,
	CLEAR_PROGRAMME,
	ADD_PROGRAMME,
	UPDATE_PROGRAMME,
	REMOVE_PROGRAMME,
} from './actionTypes';

export const programme = (state = {}, action) => {
	switch (action.type) {
		case SET_PROGRAMME:
			return action.payload;
		case UPDATE_PROGRAMME:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_PROGRAMME:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_PROGRAMMES:
			return action.payload;
		case ADD_PROGRAMME:
			return [...state, action.payload];
		case UPDATE_PROGRAMME:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_PROGRAMME:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_PROGRAMMES:
			return [];
		default:
			return state;
	}
};
